import SetRoute from '../services/setRoute';

export const fetchHomeArticles = (
    fetch,
    param = '',
) => (
    {
        payload: {
            dataset: 'home_articles',
            action: 'get',
            route: SetRoute + `/api/v1/featured_content${param}`,
            data: {},
        },
        fetch,
    }
);

export default fetchHomeArticles;
